import React from "react";
import QueryReTable from "../components/QueryReTable";
import { useUserServices } from "../context/DealerProfile";
import ReturnLists from "../features/return/ReturnLists";
import useQueryTable from "../hooks/useQueryTable";
import { useEffect } from "react";

const ReturnHistoryPage = () => {
  const {
    dealerDetail: { accountName, isChannelPartner, dealerName },
  } = useUserServices();

  const [isLoading, data, searchValues, setSearchValues, moreData, totalData] =
    useQueryTable({
      queryList: ["page", "Stage"],
      url: `/server/dealer_backend/${
        isChannelPartner
          ? "return-order-history"
          : "return-order-history-customer"
      }/${isChannelPartner ? accountName?.id : dealerName?.id}`,
    });

  const {
    data: { data: returns },
  } = data ?? { data: { data: [] } };

   
    

  console.log({ returns });

  return (
    <QueryReTable
      heading={"Return History"}
      headingNeed={true}
      moreData={moreData}
      buttonNeed={true}
      buttonText="Select Order To Create Return"
      buttonNavigation="/order-history?page=1&Stage=Invoice+%3A+Invoiced"   //Stage=Order+%3A+Invoiced"
      searchValues={searchValues}
      setSearchValues={setSearchValues}
      totalData={totalData}
    >
      <ReturnLists isLoading={isLoading} setSearchValues={setSearchValues} returns={returns} />
    </QueryReTable>
  );
};

export default ReturnHistoryPage;
